import React, { useState, useEffect, useRef } from 'react'
import { Modal, Select, Col, Row, Form, Input, Button, Typography, Checkbox, Skeleton, Collapse, Popover, Spin } from 'antd'
import { FaAngleDown, FaInfoCircle, FaRegEnvelope } from "react-icons/fa";
import { getfilteredCountries } from '../../../utils/Constants';
import { fetchflightProcessTBO, getIPAddress, getIPData, payNowflightTBO } from '../../../services/flight/flightServices';
import TravellerDetails from './TravellerDetails';
import DepartureBaggageDetails from './DepartureBaggageDetails';
import ReturnBaggageDetails from './ReturnBaggageDetails';
import DepartureReviewCard from './DepartureReviewCard';
import ReturnReviewCard from './ReturnReviewCard';
import { flightLoader } from '../../../utils/ImagePath';
import TextArea from 'antd/es/input/TextArea';
import BookingFilter from './BookingFilter';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import AddonsFlight from './AddonsFlight';
import ConvenienceChargeTotalFare from './ConvenienceChargeTotalFare';
import FilteredInput from '../../../layout/FilteredInput.jsx';
import FlightSummaryCollapseTbo from './FlightSummaryCollapseTbo.jsx';
import TravellersCardCollapsetbo from './TravellersCardCollapsetbo.jsx';

const BookingFlight = ({
    flightDetails,
    location,
    loading,
    swtFee,
    convenienceCharge,
    setConvenienceProceed,
    setSelectedBaggages,
    selectedBaggages,
    totalAmount,
    addBaggage,
    removeBaggage,
    totalPriceBaggages,
    mealTotalAmount,
    totalSelectedTravellers,
    addMeal,
    removeMeal,
    selectedMeals,
    selectedMealsReturn,
    mealTotalAmountRetrun,
    addMealReturn,
    removeMealReturn,
    calculatedFee,
    finalTotal,
    applicableChargeData,
    couponId,
    setCouponId,
    applyDiscountShow,
    setApplyDiscountShow,
    discountAmountOffer,
    setDiscountAmountOffer,
    totalAfterDiscount,
    setTotalAfterDiscount,
    outputData,
    outputDataReturn,
    meelBaggegasData,
    errorMeelBaggegas,
    selectedBaggagesReturn,
    setSelectedBaggagesReturn,
    totalAmountReturn,
    addBaggageReturn,
    removeBaggageReturn,
    setFlightOffersHideShow,

    setMealTotalAmount,
    setTotalAmount,
    setMealTotalAmountReturn,
    setTotalAmountReturn,
    setConvenienceChargeTotalFareModal,
    convenienceChargeTotalFareModal,
    skipAddonAndPayNow,
    skipAddons,
    setSkipAddons,
    collapseCard,
    setCollapseCard,
    getTotalSelectedBaggages,
    getTotalSelectedBaggagesReturn,
    collapseCardTravellers,
    setCollapseCardTravellers,
    setSelectedMeals,
    setSelectedMealsReturn,

    rowsByFlight,
    setRowsByFlight,
    legends,
    setLegends,
    selectedSeats,
    setSelectedSeats,
    totalPrice,
    setTotalPrice,
    handleSeatClick,
    totalSeatsPrice,

    rowsByFlightReturn,
    setRowsByFlightReturn,
    legendsReturn,
    setLegendsReturn,
    selectedSeatsReturn,
    setSelectedSeatsReturn,
    totalPriceReturn,
    setTotalPriceReturn,
    handleSeatClickReturn,
    totalSeatsPriceReturn,

}) => {
    const { Panel } = Collapse;
    const { Title } = Typography;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpenReturn, setIsModalOpenReturn] = useState(false);
    const [isModalTravellerDetails, setIsModalOpenTravellerDetails] = useState(false);
    const [selectPayloadData, setSelectPayloadData] = useState('')
    const [forms, setForms] = useState([]);
    const [formsChild, setFormsChild] = useState([]);

    const [checked, setChecked] = useState(false);
    const [addonsCompHide, setAddonsCompHide] = useState(true);
    const [form] = Form.useForm();


    const [bookingLoader, setBookingLoader] = useState(null)
    const [bookingMessage, setBookingMessage] = useState(null)
    const [bookingMessageError, setBookingMessageError] = useState(null)

    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1;
    const currentDay = today.getDate();


    // Days array from 1 to 31
    const days = Array.from({ length: 31 }, (_, i) => i + 1);

    // Months array
    const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];

    const pastPassportYears = Array.from({ length: 10 }, (_, i) => currentYear - i);
    const futurePassportYears = Array.from({ length: 10 }, (_, i) => currentYear + i);
    const startYearAdult = currentYear - 12;
    const endYearAdult = startYearAdult - 100 + 1;
    const AdultAgeYears = Array.from({ length: startYearAdult - endYearAdult + 1 }, (_, i) => startYearAdult - i);

    const startYearChild = currentYear - 2;
    const endYearChild = currentYear - 12;
    const ChildYears = Array.from({ length: startYearChild - endYearChild + 1 }, (_, i) => startYearChild - i);

    const startYearInfant = currentYear;
    const endYearInfant = currentYear - 2;
    const InfantYears = Array.from({ length: startYearInfant - endYearInfant + 1 }, (_, i) => startYearInfant - i);
    const [formsInfant, setFormsInfant] = useState([]);

    const getFromSessionStorage = (key, defaultValue = null) => {
        const value = sessionStorage.getItem(key);
        if (value === null || value === undefined) {
            return defaultValue;
        }
        try {
            return JSON.parse(value);
        } catch (e) {
            console.error(`Error parsing sessionStorage key "${key}":`, e);
            return defaultValue;
        }
    };

    const flightDatas = {
        departureFlight: getFromSessionStorage('DepartureFlight'),
    };

    const travel_date = moment(flightDatas?.departureFlight).format('YYYY-MM-DD')


    const handleChange = (index, key, value) => {
        const newForms = [...forms];
        newForms[index][key] = value;
        const { dobDay, dobMonth, dobYear, passportIssuingDay, passportIssuingMonth, passportIssuingYear } = newForms[index];
        if (dobDay && dobMonth && dobYear) {
            newForms[index].dob = `${dobYear}-${String(dobMonth).padStart(2, '0')}-${String(dobDay).padStart(2, '0')}`;
        }
        if (passportIssuingDay && passportIssuingMonth && passportIssuingYear) {
            newForms[index].PassportIssuing = `${passportIssuingYear}-${String(passportIssuingMonth).padStart(2, '0')}-${String(passportIssuingDay).padStart(2, '0')}`;
            // newForms[index].PassportExpiry = `${passportIssuingYear + 10}-${String(passportIssuingMonth).padStart(2, '0')}-${String(passportIssuingDay).padStart(2, '0')}`;
        }

        setForms(newForms);
    };


    const years = Array.from({ length: 3 }, (_, i) => currentYear - i);

    const daysInMonth = (month, year) => {
        return new Date(year, month, 0).getDate();
    };

    useEffect(() => {
        const initialForms = Array.from({ length: flightDetails?.flightDetails?.fareRules?.ADULT }, () => ({}));
        const formsChildForms = Array.from({ length: flightDetails?.flightDetails?.fareRules?.CHILD }, () => ({}));
        const formsInfantForms = Array.from({ length: flightDetails?.flightDetails?.fareRules?.INFANT }, () => ({}));
        setForms(initialForms);
        setFormsChild(formsChildForms);
        setFormsInfant(formsInfantForms);

    }, [flightDetails?.flightDetails?.fareRules?.ADULT, flightDetails?.flightDetails?.fareRules?.CHILD, flightDetails?.flightDetails?.fareRules?.INFANT]);

    const travelDate = new Date(travel_date);
    const minimumAllowedDOB = new Date(
        travelDate.getFullYear() - 2,
        travelDate.getMonth(),
        travelDate.getDate()
    );


    const minimumAllowedDOBInfant = new Date(travelDate.getFullYear() - 2, travelDate.getMonth(), travelDate.getDate());
    const minimumAllowedDOBChild = new Date(travelDate.getFullYear() - 12, travelDate.getMonth(), travelDate.getDate());
    const maximumAllowedDOBChild = new Date(travelDate.getFullYear() - 2, travelDate.getMonth(), travelDate.getDate());

    const handleChangeChild = (index, key, value) => {
        const newForms = [...formsChild];
        newForms[index][key] = value;

        const { dobDay, dobMonth, dobYear, passportIssuingDay, passportIssuingMonth, passportIssuingYear } = newForms[index];

        if (dobDay && dobMonth && dobYear) {
            const dob = new Date(`${dobYear}-${String(dobMonth).padStart(2, "0")}-${String(dobDay).padStart(2, "0")}`);
            newForms[index].dob = `${dobYear}-${String(dobMonth).padStart(2, "0")}-${String(dobDay).padStart(2, "0")}`;

            if (dob > today) {
                newForms[index].dobError = "Date of Birth cannot be in the future.";
            } else if (dob < minimumAllowedDOBChild || dob > maximumAllowedDOBChild) {
                newForms[index].dobError = `Child age must be between 2 and 12 years from the travel date.`;
            } else if (dob.getMonth() + 1 !== dobMonth) { // If the month/day combination is invalid for the given year
                newForms[index].dobError = `Invalid month for the selected day.`;
                newForms[index].dobMonth = null; // Unselect the month
            } else if (dob.getDate() !== dobDay) { // Check if the day is valid for the selected month
                newForms[index].dobError = `Invalid day for the selected month.`;
                newForms[index].dobDay = null; // Unselect the day
            } else {
                newForms[index].dobError = null;
            }
        } else {
            newForms[index].dob = "";
            newForms[index].dobError = "Please complete day, month, and year.";
        }

        if (passportIssuingDay && passportIssuingMonth && passportIssuingYear) {
            newForms[index].PassportIssuing = `${passportIssuingYear}-${String(passportIssuingMonth).padStart(2, '0')}-${String(passportIssuingDay).padStart(2, '0')}`;
            // newForms[index].PassportExpiry = `${passportIssuingYear + 10}-${String(passportIssuingMonth).padStart(2, '0')}-${String(passportIssuingDay).padStart(2, '0')}`;
        }

        setFormsChild(newForms);
    };

    const handleChangeInfant = (index, key, value) => {
        const newForms = [...formsInfant];
        newForms[index][key] = value;
        const { dobDay, dobMonth, dobYear, passportIssuingDay, passportIssuingMonth, passportIssuingYear } = newForms[index];
        if (dobDay && dobMonth && dobYear) {
            const dob = new Date(`${dobYear}-${String(dobMonth).padStart(2, "0")}-${String(dobDay).padStart(2, "0")}`);
            newForms[index].dob = `${dobYear}-${String(dobMonth).padStart(2, "0")}-${String(dobDay).padStart(2, "0")}`;
            // Check if the date is in the future
            if (dob > today) {
                newForms[index].dobError = "Date of Birth cannot be in the future.";
                newForms[index].dobMonth = null; // Unselect the month
                newForms[index].dobDay = null; // Unselect the day
            } else if (dob.getMonth() + 1 !== dobMonth) { // If the month/day combination is invalid for the given year
                newForms[index].dobError = `Invalid month for the selected day.`;
                newForms[index].dobMonth = null; // Unselect the month
            } else if (dob.getDate() !== dobDay) { // Check if the day is valid for the selected month
                newForms[index].dobError = `Invalid day for the selected month.`;
                newForms[index].dobDay = null; // Unselect the day
            } else if (dob < minimumAllowedDOBInfant) { // Check if the date is too far in the past (less than 2 years from today)
                newForms[index].dobError = `Infant age must be less than 2 years from the travel date.`;
                newForms[index].dobMonth = null; // Unselect the month
                newForms[index].dobDay = null; // Unselect the day
            } else {
                newForms[index].dobError = null;
            }
        } else { // If any of the day, month, or year is missing
            newForms[index].dobError = "Please select a valid date.";
        }
        if (passportIssuingDay && passportIssuingMonth && passportIssuingYear) {
            newForms[index].PassportIssuing = `${passportIssuingYear}-${String(passportIssuingMonth).padStart(2, '0')}-${String(passportIssuingDay).padStart(2, '0')}`;
            // newForms[index].PassportExpiry = `${passportIssuingYear + 10}-${String(passportIssuingMonth).padStart(2, '0')}-${String(passportIssuingDay).padStart(2, '0')}`;
        }
        setFormsInfant(newForms);
    };

    const getDisabledMonths = (selectedYear) => {
        if (selectedYear === undefined || selectedYear === null) {
            return [
                'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
            ];
        } else if (selectedYear < currentYear) return [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        ];
        return months.slice(0, currentMonth);
    };

    const getDisabledDays = (selectedYear, selectedMonth) => {
        const daysInMonth = new Date(selectedYear, selectedMonth, 0).getDate();
        if (selectedYear < currentYear || selectedMonth < currentMonth) {
            return Array.from({ length: daysInMonth }, (_, i) => i + 1);
        };
        if (selectedYear === currentYear && selectedMonth === currentMonth) return days.slice(0, currentDay);
        return days;
    };


    const onChange = (e) => {
        setChecked(e.target.checked);
    };

    const [phone, setPhone] = useState("");
    const [isValid, setIsValid] = useState(false);
    const [isValidReq, setIsValidReq] = useState(false);
    const [locationData, setLocationData] = useState(null);
    const [processResponse, setProcessResponse] = useState(null);
    const [returnFlight, setReturnFlight] = useState(null);
    const [bookingProceedLoader, setBookingProceedLoader] = useState(false);

    useEffect(() => {
        const storedFlight = sessionStorage.getItem('returnFlight');
        if (storedFlight) {
            setReturnFlight(JSON.parse(storedFlight));
        }
    }, []);

    let selectedCards = location.state.selectedCards;
    let selectedCardReturn = location?.state?.selectedCardReturn;


    const [deviceInfo, setDeviceInfo] = useState({ type: '1' });

    useEffect(() => {
        const ua = navigator.userAgent;
        let deviceType = '1';

        if (/Mobi|Android/i.test(ua)) {
            deviceType = '3';
        }

        setDeviceInfo({ type: deviceType });
    }, []);

    const [passengersDetails, setPassengersDetails] = useState(null)
    const generateTravellerInfo = (passengerCounts, values, formsData, BaseFare, Tax) => {
        const paxTypeMapping = {
            ADULT: 1,
            CHILD: 2,
            INFANT: 3,
        };

        const createTraveller = (PaxType, index, formsData, baggage) => {
            const Title = values[`${PaxType}_title${index}`] || "";
            const FirstName = values[`${PaxType}_firstname${index}`] || "";
            const LastName = values[`${PaxType}_lastname${index}`] || "";
            const genderValue = values[`${PaxType}_gender${index}`] || "";
            const Gender = genderValue === "Male" ? 1 : genderValue === "Female" ? 2 : 3;
            const CountryCode = values[`${PaxType}_CountryCode${index}`] || "";
            const CountryName = values[`${PaxType}_CountryCode${index}`] || "";
            const PassportNo = values[`${PaxType}_passportId${index}`] || "";
            const DateOfBirth = formsData?.[index]?.dob || null;
            const PassportExpiry = formsData?.[index]?.PassportIssuing || null;
            // const PassportExpiry = formsData?.[index]?.PassportExpiry || null;
            let BaseFare = flightDetails?.flightDetails?.flights?.[0]?.segments?.[0]?.fare?.BaseFare;
            let Tax = flightDetails?.flightDetails?.flights?.[0]?.segments?.[0]?.fare?.Tax;
            const Fare = {
                BaseFare,
                Tax,
                TransactionFee: 0,
                YQTax: 0,
                AdditionalTxnFeeOfrd: 0,
                AdditionalTxnFeePub: 0,
                AirTransFee: 0,
            };
            const MealDynamic = selectedMeals?.[0]?.selectedMeals || [];
            const Baggage = baggage ? [baggage] : [];

            return {
                Title,
                FirstName,
                LastName,
                PaxType: paxTypeMapping[PaxType],
                Gender,
                CountryCode,
                CountryName,
                PassportNo,
                DateOfBirth,
                PassportExpiry,
                Fare,
                MealDynamic,
                Baggage
            };
        };

        const passengers = [];
        const baggageList = selectedBaggages?.[0] || [];
        let baggageIndex = 0;

        Object.keys(passengerCounts).forEach((PaxType) => {
            const count = passengerCounts[PaxType];
            for (let i = 0; i < count; i++) {
                const baggage = baggageIndex < baggageList.length ? baggageList[baggageIndex] : null;
                passengers?.push(createTraveller(PaxType?.toUpperCase(), i, formsData[PaxType], baggage));
                baggageIndex++;
            }
        });
        return passengers;
    };

    const validatePassengers = (payload) => {
        return payload.some(passenger => {
            const dob = passenger.DateOfBirth ? new Date(passenger.DateOfBirth) : null;
            return (
                (passenger.PaxType === 2 && (dob < minimumAllowedDOBChild || dob > maximumAllowedDOBChild)) ||
                (passenger.PaxType === 3 && dob < minimumAllowedDOBInfant)
            );
        });
    };

    const constructPayload = (values, passengers) => {
        setPassengersDetails(passengers)
        const baseBooking = {
            traceId: location?.state?.traceId,
            resultIndex: location?.state?.ResultIndex || selectedCards,
            cabinClass: flightDetails?.flightDetails?.flights?.[0]?.segments?.[0]?.cabinClass,
            origin: flightDetails?.flightDetails?.flights?.[0]?.originCity,
            destination: flightDetails?.flightDetails?.flights?.[0]?.destinationCity,
            passengers,
            ...(checked && {
                gstInfo: {
                    gstNumber: values?.gstNumber,
                    email: values?.businessEmail,
                    registeredName: values?.registeredName,
                    mobile: String(values?.contact || ""),
                    address: String(values?.address_company || ""),
                },
            }),
            deliveryInfo: {
                emails: [String(values?.email)],
                contacts: [String(phone)],
                billing_address: String(values?.billing_address || ""),
            },
        };

        const returnBooking = flightDetails?.flightDetails?.checkFlightType === "DOMESTIC" && returnFlight === "roundTrip" ? {
            ...baseBooking,
            resultIndex: `${selectedCardReturn}`,
            origin: flightDetails?.flightDetails?.flights?.[0]?.destinationCity,
            destination: flightDetails?.flightDetails?.flights?.[0]?.originCity,
            deliveryInfo: {
                emails: [String(values?.email)],
                contacts: [String(values?.contact)],
                billing_address: String(values?.billing_address || ""),
            },
        } : null;

        return {
            bookings: returnBooking ? [baseBooking, returnBooking] : [baseBooking],
            device_type: Number(deviceInfo.type),

        };
    };
    const [proceedErrorMessage, setProceedErrorMessage] = useState(null);
    const [proceedErrorMessageHide, setProceedErrorMessageHide] = useState(false);

    const onPayment = async (values) => {
        try {
            setBookingProceedLoader(true);
            const passengerCounts = {
                adult: flightDetails?.flightDetails?.fareRules?.ADULT || 0,
                child: flightDetails?.flightDetails?.fareRules?.CHILD || 0,
                infant: flightDetails?.flightDetails?.fareRules?.INFANT || 0,
            };

            const formsData = { adult: forms, child: formsChild, infant: formsInfant };
            const passengers = generateTravellerInfo(passengerCounts, values, formsData);
            const payload = constructPayload(values, passengers);
            setIsModalOpenTravellerDetails(false);

            const response = await fetchflightProcessTBO(payload);

            setProcessResponse(response);
            setBookingMessageError(false);
            setBookingProceedLoader(false);
            setIsModalOpenTravellerDetails(true);
            setFlightOffersHideShow(true)
            setConvenienceProceed(true);
            setAddonsCompHide(true);
            setSelectPayloadData(payload);
        } catch (error) {
            setProceedErrorMessage(error?.response?.data?.message)
            setProceedErrorMessageHide(true)
            // setBookingProceedLoader(false);
            setBookingMessageError(true);
            setIsModalOpenTravellerDetails(false);
            setBookingMessage(error?.response?.data?.message || "An error occurred while processing payment.");
        }
    };

    const handleConfirmAndPay = async () => {
        setBookingLoader(true);
        const payload = {
            bookingId: processResponse?.bookingId,
            flight: outputData,
            returnflight: outputDataReturn,

            convenience_id: applicableChargeData?.id,
            ...(applyDiscountShow && { coupon_id: Number(couponId) }),
        };
        try {
            const response = await payNowflightTBO(payload);
            setBookingLoader(false);
            if (response?.payment_links?.web) {
                window.location.href = response.payment_links.web;
                //  window.open(response.payment_links.web, '_blank', 'noopener,noreferrer');
            }

        } catch (error) {
            setBookingLoader(true);
            setIsModalOpenTravellerDetails(false);
            console.error("Payment Error:", error);
        }
    };

    const handleSkipAddon = async () => {
        setBookingLoader(true);
        const payload = {
            bookingId: processResponse?.bookingId,
            flight: {
                meals: [],
                baggages: [],
            },
            returnflight: {
                meals: [],
                baggages: [],
            },

            convenience_id: applicableChargeData?.id,
            ...(applyDiscountShow && { coupon_id: Number(couponId) }),
        };

        try {
            const response = await payNowflightTBO(payload);
            if (response?.payment_links?.web) {
                window.location.href = response.payment_links.web;
            }

        } catch (error) {
            setBookingLoader(true);
            setIsModalOpenTravellerDetails(false);
            console.error("Payment Error:", error);
        }
    };

    const [updated, setUpdated] = useState(false);

    const createSummary = (adultTitle, firstName, lastName, dob, nationality, passportNumber, passportExpiry) => {
        let summary = "";
        if (adultTitle) summary += `Name: ${adultTitle} `;
        if (firstName) summary += `${firstName} `;
        if (lastName) summary += `${lastName} `;
        if (dob) summary += `DOB: ${dob} `;
        if (nationality) summary += `Nationality: ${nationality} `;
        return summary.trim();
    };

    const renderHeader = (index) => {
        const adultTitle = form.getFieldValue(`ADULT_title${index}`) || '';
        const firstName = form.getFieldValue(`ADULT_firstname${index}`) || '';
        const lastName = form.getFieldValue(`ADULT_lastname${index}`) || '';

        const dob = forms[index].dob || '';
        const nationality = form.getFieldValue(`ADULT_Nationality${index}`) || '';
        const passportNumber = form.getFieldValue(`ADULT_passportId${index}`) || '';
        const passportExpiry = forms[index].PassportIssuing || '';
        // const passportExpiry = forms[index].passportExpiry || '';

        return (
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>{`Adult ${index + 1}`}</div>
                <div style={{ fontSize: "10px" }}>
                    {createSummary(adultTitle, firstName, lastName, dob, nationality, passportNumber, passportExpiry)}
                </div>
            </div>
        );
    };

    const [open, setOpen] = useState(false);
    const handleOpenChange = (newOpen) => {
        setOpen(newOpen);
    };

    const component4Ref = useRef(null);

    const handleScroll = () => {
        setTimeout(() => {
            if (component4Ref.current) {
                const elementPosition = component4Ref.current.getBoundingClientRect().top + window.scrollY;
                const offsetPosition = elementPosition - 100;
                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth",
                });
            }
        }, 500);
    };

    const handleFinishFailed = () => {
        handleScroll();
    };

    const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
    const [isFormValid, setIsFormValid] = useState(false);
    const [hasTriedSubmit, setHasTriedSubmit] = useState(false);
    const allValues = Form.useWatch([], form);

    const handleProceed = async () => {
        try {
            await form.validateFields();
        } catch (error) {
            const errorFields = error.errorFields.map((field) => field.name[0]);
            let errorPanels = [...new Set(errorFields.map((field) => {
                const match = field.match(/\d+/);
                const index = match ? parseInt(match[0]) : 0;

                if (field.startsWith("ADULT")) {
                    return index.toString();
                } else if (field.startsWith("CHILD")) {
                    return (forms.length + index).toString();
                } else if (field.startsWith("INFANT")) {
                    return (forms.length + formsChild.length + index).toString();
                } else if (field.startsWith("PassportIssuing") || field.startsWith("dob")) {
                    return index.toString();
                }
                return null;
            }).filter(Boolean))];

            setActivePanels(errorPanels);

            setTimeout(() => {
                const firstErrorField = document.querySelector(".ant-form-item-has-error");
                if (firstErrorField) {
                    firstErrorField.scrollIntoView({
                        behavior: "smooth",
                        block: "center"
                    });
                    firstErrorField.classList.add("error-highlight");
                    setTimeout(() => firstErrorField.classList.remove("error-highlight"), 2000);
                }
            }, 500);
            return;
        }

        if (!phone.trim()) {
            setIsValidReq(true);
            scrollToElement("phone-input-container");
            return;
        } else if (!isValid) {
            scrollToElement("phone-input-container");
            return;
        }

        let newActivePanels = [];
        let firstErrorFieldId = null;

        forms.forEach((_, index) => {
            const panelKey = index.toString();
            if (!form.getFieldValue(`ADULT_title${index}`) && !firstErrorFieldId) {
                newActivePanels.push(panelKey);
                firstErrorFieldId = `ADULT_title${index}`;
            }
        });
        formsChild.forEach((_, index) => {
            const panelKey = (forms.length + index).toString();
            if (!form.getFieldValue(`CHILD_title${index}`) && !firstErrorFieldId) {
                newActivePanels.push(panelKey);
                firstErrorFieldId = `CHILD_title${index}`;
            }
        });

        const updatedInfants = formsInfant.map((infant, index) => {
            const panelKey = (forms.length + formsChild.length + index).toString();
            if ((!infant.dobDay || !infant.dobMonth || !infant.dobYear) && !firstErrorFieldId) {
                newActivePanels.push(panelKey);
                firstErrorFieldId = `INFANT_dob${index}`;
                return { ...infant, dobError: "Date of Birth is required" };
            }
            return { ...infant, dobError: null };
        });
        setFormsInfant(updatedInfants);

        if (firstErrorFieldId) {
            setActivePanels([...new Set(newActivePanels)]);
            setTimeout(() => scrollToElement(firstErrorFieldId), 100);
            return;
        }
        onPayment(form.getFieldsValue());
    };

    const scrollToElement = (elementId) => {
        const element = document.getElementById(elementId) ||
            document.querySelector(`[name="${elementId}"]`);

        if (element) {
            element.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });

            if (element.focus) element.focus();
            element.classList.add("error-highlight");
            setTimeout(() => element.classList.remove("error-highlight"), 2000);
        }
    };

    useEffect(() => {
        const timeoutId = setTimeout(async () => {
            if (!hasTriedSubmit && !isCheckboxChecked) return;
            if (!isValid && phone) {
                setIsFormValid(false);
                return;
            }
            try {
                await form.validateFields();
                const hasInfantDOBError = formsInfant.some(
                    form => !form.dobDay || !form.dobMonth || !form.dobYear
                );
                setIsFormValid(!hasInfantDOBError && isCheckboxChecked);
            } catch {
                setIsFormValid(false);
            }
        }, 300);

        return () => clearTimeout(timeoutId);
    }, [allValues, formsInfant, hasTriedSubmit, isCheckboxChecked, phone]);

    useEffect(() => {
        const fetchIPAddress = async () => {
            try {
                const ip = await getIPAddress();
                const data = await getIPData(ip?.ip);
                setLocationData(data);
            } catch (error) {
                console.log("error", error)
            }
        };

        fetchIPAddress();
    }, []);


    const [isFocused, setIsFocused] = useState(false);

    const handlePhoneChange = (value, country) => {
        const countryIso2 = country?.iso2 || locationData?.countryCode?.toLowerCase() || 'IN';
        const phoneNumber = parsePhoneNumberFromString(value, countryIso2);

        if (!value.trim()) {
            setIsValidReq(true);
            setIsValid(false);
        } else {
            setIsValidReq(false);
        }
        if (phoneNumber) {
            const isValidNumber = phoneNumber.isValid();
            setPhone(value);
            setIsValid(isValidNumber);

        } else {
            setIsValid(false);
        }
    };

    const fullNames = passengersDetails?.map(p => `${p.FirstName} ${p.LastName}`).join(', ');

    const [collapseCardActive, setCollapseCardActive] = useState(false);
    const [activePanels, setActivePanels] = useState([]);
    const [isInitialLoad, setIsInitialLoad] = useState(true);

    const getAllPanelKeys = () => {
        return [
            ...forms.map((_, i) => i.toString()),
            ...formsChild.map((_, i) => (forms.length + i).toString()),
            ...formsInfant.map((_, i) => (forms.length + formsChild.length + i).toString())
        ];
    };

    const handlePanelChange = (keys) => {
        setActivePanels(keys);
        setIsInitialLoad(false);
    };

    const handleEditClick = () => {
        setCollapseCard(true);
        setCollapseCardTravellers(true);
        setAddonsCompHide(true);
        setMealTotalAmount(0);
        setMealTotalAmountReturn(0);
        setTotalAmount(0);
        setTotalAmountReturn(0);
        setSelectedMeals({});
        setSelectedMealsReturn({});
        setSelectedBaggages([]);
        setSelectedBaggagesReturn([]);
        form.resetFields(["agree"]);
        setActivePanels(getAllPanelKeys());
        setIsInitialLoad(false);
    };

    useEffect(() => {
        if (isInitialLoad && forms.length > 0) {
            setActivePanels(['0']);
        }
    }, [forms.length, isInitialLoad]);


    const validateName = (_, value) => {
        if (!value) return Promise.reject("This field is required");
        const nameRegex = /^[A-Za-z]+( [A-Za-z]+)*$/;
        if (!nameRegex.test(value)) {
            return Promise.reject("Only letters and single space between words");
        }
        if (value.length < 2 || value.length > 100) {
            return Promise.reject("Must be 2–100 characters");
        }
        return Promise.resolve();
    };

    const sanitizeName = (e) => {
        let value = e.target.value || "";
        value = value.replace(/^\s+/, "");
        value = value.replace(/\s{2,}/g, " ");
        value = value.replace(/[^A-Za-z ]/g, "");
        return value;
    };

    return (
        <>
            {!collapseCard &&
                <FlightSummaryCollapseTbo
                    flightDetails={flightDetails}
                    collapseCard={collapseCard}
                    setCollapseCard={setCollapseCard}
                    setAddonsCompHide={setAddonsCompHide}
                />
            }

            {collapseCard &&
                <>
                    {/*  Departure booking review card */}
                    <DepartureReviewCard
                        flightDetails={flightDetails}
                        loading={loading}
                        setIsModalOpen={setIsModalOpen}
                        collapseCard={collapseCard}
                        setCollapseCard={setCollapseCard}
                        setAddonsCompHide={setAddonsCompHide}
                    />

                    {/*  Retrun booking review card */}
                    {flightDetails?.flightDetails?.returnFlight?.[0]?.segments !== undefined &&
                        <ReturnReviewCard
                            flightDetails={flightDetails}
                            loading={loading}
                            setIsModalOpenReturn={setIsModalOpenReturn}
                            collapseCard={collapseCard}
                            setCollapseCard={setCollapseCard}
                            setAddonsCompHide={setAddonsCompHide}
                        />
                    }
                </>
            }

            {collapseCard &&
                <div className="d-md-none">
                    <BookingFilter
                        flightDetails={flightDetails}
                        loading={loading}
                        swtFee={swtFee}
                        setSelectedBaggages={setSelectedBaggages}
                        selectedBaggages={selectedBaggages}
                        totalAmount={totalAmount}
                        totalPriceBaggages={totalPriceBaggages}
                        setTotalAmount={setTotalAmount}
                        addBaggage={addBaggage}
                        removeBaggage={removeBaggage}
                        totalSelectedTravellers={totalSelectedTravellers}
                        mealTotalAmount={mealTotalAmount}
                        couponId={couponId}
                        setCouponId={setCouponId}
                        applyDiscountShow={applyDiscountShow}
                        setApplyDiscountShow={setApplyDiscountShow}
                        discountAmountOffer={discountAmountOffer}
                        setDiscountAmountOffer={setDiscountAmountOffer}
                        totalAfterDiscount={totalAfterDiscount}
                        setTotalAfterDiscount={setTotalAfterDiscount}
                    />
                </div>
            }

            {!collapseCard &&
                <div className="card flights-accordion traveller-details mb-0" id='TravellerDetails'>
                    <div className="card-header d-flex justify-content-between align-items-center cursor-pointer" onClick={() => setCollapseCardTravellers(!collapseCardTravellers)}>
                        <div className='d-flex'>
                            <h3 className='me-2'>Traveller Details   </h3>
                            {!collapseCard && <p>{fullNames}</p>}
                        </div>
                        {!collapseCard && <FaAngleDown />}
                    </div>
                    {!collapseCardTravellers &&
                        <TravellersCardCollapsetbo
                            selectPayloadData={selectPayloadData}
                            handleEditClick={handleEditClick}
                        />
                    }
                </div>
            }

            <div ref={component4Ref}>
                {collapseCard &&
                    <Form
                        form={form}
                        // onFinish={!addonsCompHide ? onPayment : onFinish}
                        onFinish={onPayment}
                        layout="vertical"
                        autoCapitalize='off'
                        onFinishFailed={handleFinishFailed}
                        scrollToFirstError
                    >
                        <Skeleton
                            paragraph={{ rows: 4, }}
                            loading={loading}
                            style={{ background: "#fff" }}
                            className='p-4 mb-4'
                        >
                            <div className="card flights-accordion traveller-details mb-0" id='TravellerDetails'>
                                <div className="card-header d-flex justify-content-between align-items-center">
                                    <div className='d-flex'>
                                        <h3 className='me-2'>Traveller Details  </h3>
                                        {!collapseCard && <p>{fullNames}</p>}
                                    </div>
                                </div>

                                {collapseCard &&
                                    <div className="flights-list-item bg-white rounded-3 p-3">
                                        {/* <h4 className='mb-2'>Adult 1</h4> */}
                                        <Collapse
                                            activeKey={activePanels}
                                            accordion={false}
                                            onChange={handlePanelChange}
                                            className='mt-2'>
                                            {forms?.map((form, index) => (
                                                <Panel header={`Adult ${index + 1}`} key={index.toString()}>
                                                    <Row gutter={16} key={index} className=''>

                                                        <Col md={4} className='w-100'>
                                                            <Form.Item
                                                                label="Title"
                                                                name={`ADULT_title${index}`}
                                                                className="mb-3 pulse_input"

                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: "Title is required",
                                                                    },
                                                                ]}
                                                            >
                                                                <Select
                                                                    placeholder='Select'
                                                                    onChange={() => setUpdated(!updated)}
                                                                >
                                                                    <Option value="Mr">Mr</Option>
                                                                    <Option value="Ms">Ms</Option>
                                                                    <Option value="Mrs">Mrs</Option>
                                                                </Select>
                                                            </Form.Item>
                                                        </Col>

                                                        <Col md={8} className='w-100'>
                                                            <Form.Item
                                                                name={`ADULT_firstname${index}`}
                                                                label="First Name"
                                                                className="mb-3 pulse_input"
                                                                rules={[{ validator: validateName }]}
                                                                getValueFromEvent={sanitizeName}
                                                            >
                                                                <FilteredInput
                                                                    placeholder='Enter your first name'
                                                                    onChange={() => setUpdated(!updated)}

                                                                />
                                                            </Form.Item>
                                                        </Col>

                                                        <Col md={8} className='w-100'>
                                                            <Form.Item
                                                                name={`ADULT_lastname${index}`}
                                                                label="Last Name"
                                                                className="mb-3 pulse_input"
                                                                rules={[{ validator: validateName }]}
                                                                getValueFromEvent={sanitizeName}
                                                            >
                                                                <FilteredInput
                                                                    placeholder='Enter your last name'
                                                                    onChange={() => setUpdated(!updated)}
                                                                />
                                                            </Form.Item>
                                                        </Col>

                                                        <Col md={4} className='w-100'>
                                                            <Form.Item
                                                                label="Gender"
                                                                name={`ADULT_gender${index}`}
                                                                className="mb-3 pulse_input"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: "Gender is required",
                                                                    },
                                                                ]}
                                                            >
                                                                <Select
                                                                    placeholder='Select Gender'
                                                                    onChange={() => setUpdated(!updated)}
                                                                >
                                                                    <Option value="Male">Male</Option>
                                                                    <Option value="Female">Female</Option>
                                                                    <Option value="Other">Other</Option>
                                                                </Select>
                                                            </Form.Item>
                                                        </Col>
                                                        {flightDetails?.flightDetails?.checkFlightType === "INTERNATIONAL" &&
                                                            <>
                                                                <Col md={8} className='w-100'>
                                                                    <Form.Item
                                                                        name={`dob${index}`}
                                                                        label="Date of Birth"
                                                                        rules={[
                                                                            {
                                                                                validator: (_, value) => {
                                                                                    const day = form.dobDay;
                                                                                    const month = form.dobMonth;
                                                                                    const year = form.dobYear;
                                                                                    if (!day || !month || !year) {
                                                                                        return Promise.reject('Date of Birth is required');
                                                                                    }
                                                                                    return Promise.resolve();
                                                                                }
                                                                            }
                                                                        ]}
                                                                        validateTrigger={['onChange', 'onBlur']}
                                                                    >
                                                                        <Row gutter={4}>
                                                                            <Col span={8}>
                                                                                <Select
                                                                                    placeholder="Day"
                                                                                    value={form.dobDay}
                                                                                    onChange={(value) => handleChange(index, 'dobDay', value)}
                                                                                    style={{ width: '100%' }}
                                                                                >
                                                                                    {days.map(d => (
                                                                                        <Select.Option key={`dob-day-${d}`} value={d}>{d}</Select.Option>
                                                                                    ))}
                                                                                </Select>
                                                                            </Col>
                                                                            <Col span={8}>
                                                                                <Select
                                                                                    placeholder="Month"
                                                                                    value={form.dobMonth}
                                                                                    onChange={(value) => handleChange(index, 'dobMonth', value)}
                                                                                    style={{ width: '100%' }}
                                                                                >
                                                                                    {months.map((m, idx) => (
                                                                                        <Select.Option key={`dob-month-${idx + 1}`} value={idx + 1}>{m}</Select.Option>
                                                                                    ))}
                                                                                </Select>
                                                                            </Col>
                                                                            <Col span={8}>
                                                                                <Select
                                                                                    placeholder="Year"
                                                                                    value={form.dobYear}
                                                                                    onChange={(value) => handleChange(index, 'dobYear', value)}
                                                                                    style={{ width: '100%' }}
                                                                                    rules={[
                                                                                        {
                                                                                            required: true,
                                                                                            message: "Last name is required",
                                                                                        },
                                                                                    ]}
                                                                                >
                                                                                    {AdultAgeYears.map(y => (
                                                                                        <Select.Option key={`dob-year-${y}`} value={y}>{y}</Select.Option>
                                                                                    ))}
                                                                                </Select>
                                                                            </Col>
                                                                        </Row>
                                                                    </Form.Item>

                                                                </Col>

                                                                <Col md={8} className='w-100'>
                                                                    <Form.Item
                                                                        label="Nationality"
                                                                        name={`ADULT_CountryCode${index}`}
                                                                        className="mb-3 pulse_input"
                                                                        rules={[
                                                                            {
                                                                                required: true,
                                                                                message: "Nationality is required",
                                                                            },
                                                                        ]}
                                                                    >
                                                                        <Select
                                                                            showSearch
                                                                            placeholder="Select a country"
                                                                            optionFilterProp="label"
                                                                            value={form.passportIssuingCountry}
                                                                            onChange={(value) => handleChange(index, 'passportIssuingCountry', value)}
                                                                            options={getfilteredCountries?.map((country, i) => ({
                                                                                value: country.code,
                                                                                label: country.name,
                                                                            }))}
                                                                        />
                                                                    </Form.Item>
                                                                </Col>

                                                                <Col md={8} className='w-100'>
                                                                    <Form.Item
                                                                        name={`ADULT_passportId${index}`}
                                                                        label="Passport Number"
                                                                        className="mb-3 pulse_input"
                                                                        rules={[
                                                                            {
                                                                                required: true,
                                                                                message: "Passport Number is required!",
                                                                            },
                                                                            {
                                                                                pattern: /^[A-PR-WY][0-9]{7}$/,
                                                                                message: "Enter a valid Passport Number (e.g. K1234567)",
                                                                            },
                                                                        ]}

                                                                    >
                                                                        <Input
                                                                            placeholder='Enter your passport number'
                                                                            value={form.passportId}
                                                                            onChange={(e) => handleChangeInfant(index, 'passportId', e.target.value)}
                                                                        />
                                                                    </Form.Item>
                                                                </Col>

                                                                <Col md={8} className='w-100'>
                                                                    <Form.Item
                                                                        name={`PassportIssuing${index}`}
                                                                        label="Passport Expiry Date"
                                                                        rules={[
                                                                            {
                                                                                validator: (_, value) => {
                                                                                    const day = form.passportIssuingDay;
                                                                                    const month = form.passportIssuingMonth;
                                                                                    const year = form.passportIssuingYear;
                                                                                    if (!day || !month || !year) {
                                                                                        return Promise.reject('Passport expiry date is required');
                                                                                    }
                                                                                    return Promise.resolve();
                                                                                }
                                                                            }
                                                                        ]}
                                                                        validateTrigger={['onChange', 'onBlur']}
                                                                    >
                                                                        <Row gutter={4} className=''>
                                                                            <Col span={8}>
                                                                                <Select
                                                                                    placeholder="Day"
                                                                                    onChange={(value) => handleChange(index, 'passportIssuingDay', value)}
                                                                                    value={form.passportIssuingDay}
                                                                                    style={{ width: '100%' }}
                                                                                >
                                                                                    {days.map(d => (
                                                                                        <Option key={`passport-day-${d}`} value={d}>{d}</Option>
                                                                                    ))}
                                                                                </Select>
                                                                            </Col>
                                                                            <Col span={8}>
                                                                                <Select
                                                                                    placeholder="Month"
                                                                                    onChange={(value) => handleChange(index, 'passportIssuingMonth', value)}
                                                                                    value={form.passportIssuingMonth}
                                                                                    style={{ width: '100%' }}
                                                                                >
                                                                                    {months.map((m, idx) => (
                                                                                        <Option key={`passport-month-${idx + 1}`} value={idx + 1}>{m}</Option>
                                                                                    ))}
                                                                                </Select>
                                                                            </Col>
                                                                            <Col span={8}>
                                                                                <Select
                                                                                    placeholder="Year"
                                                                                    onChange={(value) => handleChange(index, 'passportIssuingYear', value)}
                                                                                    value={form.passportIssuingYear}
                                                                                    style={{ width: '100%' }}
                                                                                >
                                                                                    {futurePassportYears.map(y => (
                                                                                        <Option key={`passport-year-${y}`} value={y}>{y}</Option>
                                                                                    ))}
                                                                                </Select>
                                                                            </Col>
                                                                        </Row>
                                                                    </Form.Item>
                                                                </Col>
                                                            </>
                                                        }
                                                    </Row>
                                                </Panel>
                                            ))}

                                            {flightDetails?.searchQuery?.paxInfo?.CHILD !== 0 &&
                                                <>
                                                    {formsChild.map((form, index) => (
                                                        <Panel header={`Child ${index + 1}`} key={(forms.length + index).toString()}>
                                                            <Row gutter={16} key={index} className=''>
                                                                <Col md={4} className='w-100'>
                                                                    <Form.Item name={`CHILD_title${index}`} label="Title" className="mb-3 pulse_input"
                                                                        rules={[
                                                                            {
                                                                                required: true,
                                                                                message: "Title is required",
                                                                            },
                                                                        ]}>
                                                                        <Select placeholder='Select'>
                                                                            <Option value="Mstr">Master</Option>
                                                                            <Option value="Miss">Miss</Option>
                                                                        </Select>
                                                                    </Form.Item>
                                                                </Col>

                                                                <Col md={8} className='w-100'>
                                                                    <Form.Item
                                                                        name={`CHILD_firstname${index}`}
                                                                        label="First Name"
                                                                        className="mb-3 pulse_input"
                                                                        rules={[{ validator: validateName }]}
                                                                        getValueFromEvent={sanitizeName}
                                                                    >
                                                                        <FilteredInput
                                                                            placeholder='Enter your first name'
                                                                        />
                                                                    </Form.Item>
                                                                </Col>

                                                                <Col md={8} className='w-100'>
                                                                    <Form.Item
                                                                        name={`CHILD_lastname${index}`}
                                                                        label="Last Name"
                                                                        className="mb-3 pulse_input"
                                                                        rules={[{ validator: validateName }]}
                                                                        getValueFromEvent={sanitizeName}
                                                                    >
                                                                        <FilteredInput
                                                                            placeholder='Enter your last name'
                                                                            value={form.lastname}
                                                                            onChange={(e) => handleChangeChild(index, 'lastname', e.target.value)}
                                                                        />
                                                                    </Form.Item>
                                                                </Col>


                                                                <Col md={4} className='w-100'>
                                                                    <Form.Item
                                                                        label="Gender"
                                                                        name={`CHILD_gender${index}`}
                                                                        className="mb-3 pulse_input"
                                                                        rules={[
                                                                            {
                                                                                required: true,
                                                                                message: "Gender is required",
                                                                            },
                                                                        ]}
                                                                    >
                                                                        <Select
                                                                            placeholder='Select Gender'
                                                                        >
                                                                            <Option value="Male">Male</Option>
                                                                            <Option value="Female">Female</Option>
                                                                            <Option value="Other">Other</Option>
                                                                        </Select>
                                                                    </Form.Item>
                                                                </Col>

                                                                <Col md={8} className='w-100'>
                                                                    <Form.Item
                                                                        name={`dob${index}`}
                                                                        label="Date of Birth"
                                                                        validateStatus={form.dobError ? "error" : ""}
                                                                        help={form.dobError || ""}
                                                                    >
                                                                        <Row gutter={4}>
                                                                            <Col span={8}>
                                                                                <Select
                                                                                    placeholder="Day"
                                                                                    value={form.dobDay}
                                                                                    onChange={(value) => handleChangeChild(index, 'dobDay', value)}
                                                                                    style={{ width: '100%' }}
                                                                                >
                                                                                    {getDisabledDays(form.dobYear, form.dobMonth).map((d, indx) => (
                                                                                        <Select.Option key={`dob-day-${indx}`} value={d}>{d}</Select.Option>
                                                                                    ))}
                                                                                </Select>
                                                                            </Col>
                                                                            <Col span={8}>
                                                                                <Select
                                                                                    placeholder="Month"
                                                                                    value={form.dobMonth}
                                                                                    onChange={(value) => handleChangeChild(index, 'dobMonth', value)}
                                                                                    style={{ width: '100%' }}
                                                                                >
                                                                                    {getDisabledMonths(form.dobYear).map((m, idx) => (
                                                                                        <Select.Option key={`dob-month-${idx + 1}`} value={idx + 1}>{m}</Select.Option>
                                                                                    ))}
                                                                                </Select>
                                                                            </Col>
                                                                            <Col span={8}>
                                                                                <Select
                                                                                    placeholder="Year"
                                                                                    value={form.dobYear}
                                                                                    onChange={(value) => handleChangeChild(index, 'dobYear', value)}
                                                                                    style={{ width: '100%' }}
                                                                                >
                                                                                    {ChildYears.map((y, indx) => (
                                                                                        <Select.Option key={`dob-year-${indx}`} value={y}>{y}</Select.Option>
                                                                                    ))}
                                                                                </Select>
                                                                            </Col>
                                                                        </Row>
                                                                    </Form.Item>
                                                                </Col>


                                                                {flightDetails?.flightDetails?.checkFlightType === "INTERNATIONAL" &&
                                                                    <>

                                                                        <Col md={8} className='w-100'>
                                                                            <Form.Item
                                                                                label="Nationality"
                                                                                name={`CHILD_Nationality${index}`}
                                                                                className="mb-3 pulse_input"
                                                                                rules={[
                                                                                    {
                                                                                        required: true,
                                                                                        message: "Nationality is required",
                                                                                    },
                                                                                ]}
                                                                            >
                                                                                <Select
                                                                                    showSearch
                                                                                    placeholder="Select a country"
                                                                                    optionFilterProp="label"
                                                                                    value={form.passportIssuingCountry}
                                                                                    onChange={(value) => handleChangeChild(index, 'passportIssuingCountry', value)}
                                                                                    options={getfilteredCountries.map((country, i) => ({
                                                                                        value: country.code,
                                                                                        label: country.name
                                                                                    }))}
                                                                                />
                                                                            </Form.Item>
                                                                        </Col>

                                                                        <Col md={8} className='w-100'>
                                                                            <Form.Item
                                                                                name={`CHILD_passportId${index}`}
                                                                                label="Passport Number"
                                                                                className="mb-3 pulse_input"
                                                                                rules={[
                                                                                    {
                                                                                        required: true,
                                                                                        message: "Passport Number is required!",
                                                                                    },
                                                                                    {
                                                                                        pattern: /^[A-PR-WY][0-9]{7}$/,
                                                                                        message: "Enter a valid Passport Number (e.g. K1234567)",
                                                                                    },
                                                                                ]}
                                                                            >
                                                                                <Input
                                                                                    placeholder='Enter your passport number'
                                                                                />
                                                                            </Form.Item>
                                                                        </Col>

                                                                        <Col md={8} className='w-100'>
                                                                            <Form.Item
                                                                                name={`PassportIssuing${index}`}
                                                                                label="Passport Expiry Date"
                                                                                rules={[
                                                                                    {
                                                                                        validator: (_, value) => {
                                                                                            const day = form.passportIssuingDay;
                                                                                            const month = form.passportIssuingMonth;
                                                                                            const year = form.passportIssuingYear;
                                                                                            if (!day || !month || !year) {
                                                                                                return Promise.reject('Passport expiry date is required');
                                                                                            }
                                                                                            return Promise.resolve();
                                                                                        }
                                                                                    }
                                                                                ]}
                                                                                validateTrigger={['onChange', 'onBlur']}
                                                                            >
                                                                                <Row gutter={4} className=''>
                                                                                    <Col span={8}>
                                                                                        <Select
                                                                                            placeholder="Day"
                                                                                            onChange={(value) => handleChangeChild(index, 'passportIssuingDay', value)}
                                                                                            value={form.passportIssuingDay}
                                                                                            style={{ width: '100%' }}
                                                                                        >
                                                                                            {days.map(d => (
                                                                                                <Option key={`passport-day-${d}`} value={d}>{d}</Option>
                                                                                            ))}
                                                                                        </Select>
                                                                                    </Col>
                                                                                    <Col span={8}>
                                                                                        <Select
                                                                                            placeholder="Month"
                                                                                            onChange={(value) => handleChangeChild(index, 'passportIssuingMonth', value)}
                                                                                            value={form.passportIssuingMonth}
                                                                                            style={{ width: '100%' }}
                                                                                        >
                                                                                            {months.map((m, idx) => (
                                                                                                <Option key={`passport-month-${idx + 1}`} value={idx + 1}>{m}</Option>
                                                                                            ))}
                                                                                        </Select>
                                                                                    </Col>
                                                                                    <Col span={8}>
                                                                                        <Select
                                                                                            placeholder="Year"
                                                                                            onChange={(value) => handleChangeChild(index, 'passportIssuingYear', value)}
                                                                                            value={form.passportIssuingYear}
                                                                                            style={{ width: '100%' }}
                                                                                        >
                                                                                            {futurePassportYears.map(y => (
                                                                                                <Option key={`passport-year-${y}`} value={y}>{y}</Option>
                                                                                            ))}
                                                                                        </Select>
                                                                                    </Col>
                                                                                </Row>
                                                                            </Form.Item>
                                                                        </Col>
                                                                    </>
                                                                }

                                                            </Row>
                                                        </Panel>
                                                    ))}
                                                </>
                                            }

                                            {flightDetails?.searchQuery?.paxInfo?.INFANT !== 0 &&
                                                <>
                                                    {formsInfant?.map((form, index) => (
                                                        <Panel header={`Infant ${index + 1}`} key={(forms.length + formsChild.length + index).toString()}>
                                                            <Row gutter={16} key={index} className=''>
                                                                <Col md={4} className='w-100'>
                                                                    <Form.Item name={`INFANT_title${index}`} label="Title" className="mb-3 pulse_input"
                                                                        rules={[
                                                                            {
                                                                                required: true,
                                                                                message: "Title is required",
                                                                            },
                                                                        ]}
                                                                    >
                                                                        <Select
                                                                            placeholder='Select'
                                                                        >
                                                                            <Option value="Mstr">Master</Option>
                                                                            <Option value="Miss">Miss</Option>
                                                                        </Select>
                                                                    </Form.Item>
                                                                </Col>

                                                                <Col md={8} className='w-100'>
                                                                    <Form.Item
                                                                        name={`INFANT_firstname${index}`}
                                                                        label="First Name"
                                                                        className="mb-3 pulse_input"
                                                                        rules={[{ validator: validateName }]}
                                                                        getValueFromEvent={sanitizeName}
                                                                    >
                                                                        <FilteredInput
                                                                            placeholder='Enter your first name'
                                                                        />
                                                                    </Form.Item>
                                                                </Col>

                                                                <Col md={8} className='w-100'>
                                                                    <Form.Item
                                                                        name={`INFANT_lastname${index}`}
                                                                        label="Last Name"
                                                                        className="mb-3 pulse_input"
                                                                        rules={[{ validator: validateName }]}
                                                                        getValueFromEvent={sanitizeName}
                                                                    >
                                                                        <FilteredInput
                                                                            placeholder='Enter your last name'
                                                                        />
                                                                    </Form.Item>
                                                                </Col>

                                                                <Col md={4} className='w-100'>
                                                                    <Form.Item
                                                                        label="Gender"
                                                                        name={`INFANT_gender${index}`}
                                                                        className="mb-3 pulse_input"
                                                                        rules={[
                                                                            {
                                                                                required: true,
                                                                                message: "Gender is required",
                                                                            },
                                                                        ]}
                                                                    >
                                                                        <Select
                                                                            placeholder='Select Gender'
                                                                        >
                                                                            <Option value="Male">Male</Option>
                                                                            <Option value="Female">Female</Option>
                                                                            <Option value="Other">Other</Option>
                                                                        </Select>
                                                                    </Form.Item>
                                                                </Col>

                                                                <Col md={8} className='w-100'>
                                                                    <Form.Item
                                                                        label="Date of Birth"
                                                                        validateStatus={form.dobError ? "error" : ""}
                                                                        help={form.dobError || ""}
                                                                    >
                                                                        <Row gutter={4}>
                                                                            <Col span={8}>
                                                                                <Select
                                                                                    placeholder="Day"
                                                                                    value={form.dobDay}
                                                                                    onChange={(value) => handleChangeInfant(index, 'dobDay', value)}
                                                                                    style={{ width: '100%' }}
                                                                                >
                                                                                    {getDisabledDays(form.dobYear, form.dobMonth).map((d, indx) => (
                                                                                        <Select.Option key={`dob-day-${indx + 2000}`} value={d}>{d}</Select.Option>
                                                                                    ))}
                                                                                </Select>
                                                                            </Col>
                                                                            <Col span={8}>
                                                                                <Select
                                                                                    placeholder="Month"
                                                                                    value={form.dobMonth}
                                                                                    onChange={(value) => handleChangeInfant(index, 'dobMonth', value)}
                                                                                    style={{ width: '100%' }}
                                                                                >
                                                                                    {getDisabledMonths(form.dobYear).map((m, idx) => (
                                                                                        <Select.Option key={`dob-month-${idx + 2000}`} value={idx + 1}>{m}</Select.Option>
                                                                                    ))}
                                                                                </Select>
                                                                            </Col>
                                                                            <Col span={8}>
                                                                                <Select
                                                                                    placeholder="Year"
                                                                                    value={form.dobYear}
                                                                                    onChange={(value) => handleChangeInfant(index, 'dobYear', value)}
                                                                                    style={{ width: '100%' }}
                                                                                >
                                                                                    {InfantYears.map((y, indx) => (
                                                                                        <Select.Option key={`dob-year-${indx}`} value={y}>{y}</Select.Option>
                                                                                    ))}
                                                                                </Select>
                                                                            </Col>
                                                                        </Row>
                                                                    </Form.Item>

                                                                </Col>

                                                                {flightDetails?.flightDetails?.checkFlightType === "INTERNATIONAL" &&
                                                                    <>

                                                                        <Col md={8} className='w-100'>
                                                                            <Form.Item
                                                                                label="Nationality"
                                                                                name={`INFANT_Nationality${index}`}
                                                                                className="mb-3 pulse_input"
                                                                                rules={[
                                                                                    {
                                                                                        required: true,
                                                                                        message: "Nationality is required",
                                                                                    },
                                                                                ]}
                                                                            >
                                                                                <Select
                                                                                    showSearch
                                                                                    placeholder="Select a country"
                                                                                    optionFilterProp="label"
                                                                                    value={form.passportIssuingCountry}
                                                                                    onChange={(e) => handleChangeInfant(index, 'passportIssuingCountry', e?.target?.value)}
                                                                                    options={getfilteredCountries.map((country, i) => ({
                                                                                        value: country.code,
                                                                                        label: country.name
                                                                                    }))}
                                                                                />
                                                                            </Form.Item>
                                                                        </Col>

                                                                        <Col md={8} className='w-100'>
                                                                            <Form.Item
                                                                                name={`INFANT_passportId${index}`}
                                                                                label="Passport Number"
                                                                                className="mb-3 pulse_input"
                                                                                rules={[
                                                                                    {
                                                                                        required: true,
                                                                                        message: "Passport Number is required!",
                                                                                    },
                                                                                    {
                                                                                        pattern: /^[A-PR-WY][0-9]{7}$/,
                                                                                        message: "Enter a valid Passport Number (e.g. K1234567)",
                                                                                    },
                                                                                ]}
                                                                            >
                                                                                <Input
                                                                                    placeholder='Enter your passport number'
                                                                                    value={form.passportId}
                                                                                    onChange={(e) => handleChangeInfant(index, 'passportId', e.target.value)}
                                                                                />
                                                                            </Form.Item>
                                                                        </Col>

                                                                        <Col md={8} className='w-100'>
                                                                            <Form.Item
                                                                                name={`PassportIssuing${index}`}
                                                                                label="Passport Expiry Date"
                                                                                rules={[
                                                                                    {
                                                                                        validator: (_, value) => {
                                                                                            const day = form.passportIssuingDay;
                                                                                            const month = form.passportIssuingMonth;
                                                                                            const year = form.passportIssuingYear;
                                                                                            if (!day || !month || !year) {
                                                                                                return Promise.reject('Passport expiry date is required');
                                                                                            }
                                                                                            return Promise.resolve();
                                                                                        }
                                                                                    }
                                                                                ]}
                                                                                validateTrigger={['onChange', 'onBlur']}
                                                                            >
                                                                                <Row gutter={4} className=''>
                                                                                    <Col span={8}>
                                                                                        <Select
                                                                                            placeholder="Day"
                                                                                            onChange={(value) => handleChangeInfant(index, 'passportIssuingDay', value)}
                                                                                            value={form.passportIssuingDay}
                                                                                            style={{ width: '100%' }}
                                                                                        >
                                                                                            {days.map(d => (
                                                                                                <Option key={`passport-day-${d}`} value={d}>{d}</Option>
                                                                                            ))}
                                                                                        </Select>
                                                                                    </Col>
                                                                                    <Col span={8}>
                                                                                        <Select
                                                                                            placeholder="Month"
                                                                                            onChange={(value) => handleChangeInfant(index, 'passportIssuingMonth', value)}
                                                                                            value={form.passportIssuingMonth}
                                                                                            style={{ width: '100%' }}
                                                                                        >
                                                                                            {months.map((m, idx) => (
                                                                                                <Option key={`passport-month-${idx + 1}`} value={idx + 1}>{m}</Option>
                                                                                            ))}
                                                                                        </Select>
                                                                                    </Col>
                                                                                    <Col span={8}>
                                                                                        <Select
                                                                                            placeholder="Year"
                                                                                            onChange={(value) => handleChangeInfant(index, 'passportIssuingYear', value)}
                                                                                            value={form.passportIssuingYear}
                                                                                            style={{ width: '100%' }}
                                                                                        >
                                                                                            {futurePassportYears.map(y => (
                                                                                                <Option key={`passport-year-${y}`} value={y}>{y}</Option>
                                                                                            ))}
                                                                                        </Select>
                                                                                    </Col>
                                                                                </Row>
                                                                            </Form.Item>
                                                                        </Col>
                                                                    </>}
                                                            </Row>
                                                        </Panel>
                                                    ))}
                                                </>
                                            }
                                        </Collapse>

                                        <h4 className='mt-4 mb-2'>Contact Details</h4>
                                        <Row gutter={16}>
                                            <Col md={12} className='w-100 mb-2'>
                                                <label>Mobile Number</label>
                                                {/* {!phone && !isFocused && (
                                            <div className="custom-placeholder" >Enter mobile number</div>
                                           )} */}
                                                <PhoneInput
                                                    defaultCountry={locationData?.countryCode?.toLowerCase() || 'in'}
                                                    forceDialCode={true}
                                                    disableDialCodeAndPrefix={true}
                                                    showDisabledDialCodeAndPrefix={true}
                                                    placeholder="Enter Mobile Number"
                                                    value={phone}
                                                    className={`w-100 custom-phone-inputs ${(!isValid || isValidReq) ? 'input-with-error' : ''}`}
                                                    onChange={handlePhoneChange}
                                                    onFocus={() => setIsFocused(true)}
                                                    onBlur={() => setIsFocused(false)}
                                                    disableFormatting={true}

                                                />
                                                {!isValid && phone && (
                                                    <div className='error-message'>
                                                        Please enter a valid phone number
                                                    </div>
                                                )}
                                                {isValidReq && (
                                                    <div className='error-message'>
                                                        Contact number  is required
                                                    </div>
                                                )}
                                            </Col>

                                            <Col md={12} className='w-100 mb-2'>
                                                <Form.Item
                                                    name="email"
                                                    label="Email"
                                                    className="pulse_input"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: "Email  is required",
                                                        },
                                                        {
                                                            type: 'email',
                                                            message: "Please enter a valid email address",
                                                        }
                                                    ]}
                                                    validateTrigger={['onBlur']}
                                                >
                                                    <Input
                                                        placeholder='Enter your Email'
                                                        prefix={<FaRegEnvelope className="me-2" />}
                                                    />
                                                </Form.Item>
                                                {/* <span className='d-flex justify-content-between align-items-center'>Your ticket will be sent to this email address</span> */}

                                            </Col>

                                            <Col md={24} className='w-100'>
                                                <Form.Item
                                                    name="billing_address"
                                                    label="Billing Address"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: "Billing Address is required",
                                                        },
                                                    ]}
                                                >

                                                    <TextArea
                                                        placeholder="Enter your billing address"
                                                        rows={2}
                                                        style={{ height: 'auto', }}
                                                    />
                                                </Form.Item>
                                            </Col>

                                        </Row>

                                        <Title level={5} className='fw-bold mb-2'><Checkbox onChange={onChange} /> Enter GST Details (Optional)</Title>

                                        {checked &&
                                            <div>
                                                <Row gutter={16}>
                                                    <Col md={8} xs={24} className='mb-3'>
                                                        <Form.Item
                                                            name="gstNumber"
                                                            label="GST Number"
                                                            rules={[{ required: true, message: 'Please enter GST Number' }]}
                                                        >
                                                            <Input placeholder="Enter GST Number" />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col md={8} xs={24} className='mb-3'>
                                                        <Form.Item
                                                            name="registeredName"
                                                            label="Company Name"
                                                            rules={[{ required: true, message: 'Please enter Company Name' }]}
                                                        >
                                                            <FilteredInput placeholder="Enter Company Name" />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col md={8} xs={24} className='mb-3'>
                                                        <Form.Item
                                                            name="businessEmail"
                                                            label="Business Email ID"
                                                            rules={[{ required: true, message: 'Please enter Business Email ID' }, { type: 'email', message: 'Please enter a valid email' }]}
                                                        >
                                                            <Input placeholder="Enter Business Email ID" prefix={<FaRegEnvelope />} />
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                                <Row gutter={16}>
                                                    <Col md={16} xs={24} className='mb-3'>
                                                        <Form.Item
                                                            name="address"
                                                            label="Company Address"
                                                            rules={[{ required: true, message: 'Please enter Company Address' }]}
                                                        >
                                                            <FilteredInput placeholder="Enter Company Address" />
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            </div>
                                        }

                                        <Form.Item
                                            name="agree"
                                            valuePropName="checked"
                                            rules={[
                                                {
                                                    validator: (_, value) =>
                                                        value
                                                            ? Promise.resolve()
                                                            : Promise.reject("Please click on checkbox to continue."),
                                                },
                                            ]}
                                        >
                                            <span className="mb-2 d-flex align-items-start gap-2">
                                                <Checkbox style={{ marginTop: "4px" }}
                                                    onChange={(e) => {
                                                        setIsCheckboxChecked(e.target.checked);
                                                        setHasTriedSubmit(true);
                                                    }}
                                                />
                                                <label htmlFor="terms">
                                                    I understand and agree with the{" "}

                                                    the{" "}
                                                    <Link
                                                        aria-label="Privacy Policy"
                                                        to="/privacy-policy"
                                                        target="_blank"
                                                        className="text-primary"
                                                    >
                                                        Privacy Policy
                                                    </Link>
                                                    , the{" "}
                                                    <Link
                                                        aria-label="User Agreement"
                                                        to="/user-agreement"
                                                        target="_blank"
                                                        className="text-primary"
                                                    >
                                                        User Agreement
                                                    </Link>{" "}
                                                    and{" "}

                                                    <Link
                                                        aria-label="Terms and Conditions"
                                                        to="/terms-conditions"
                                                        target="_blank"
                                                        className="text-primary"
                                                    >
                                                        Fare Rules,  Terms & Conditions
                                                    </Link>{" "}
                                                    of SuperbWorldTrip.
                                                </label>
                                            </span>
                                        </Form.Item>

                                        {/* {addonsCompHide && <Button className='btn btn-primary d-inline-block float-end  rounded my-3 d-none d-md-block' onClick={handleProceed}>Proceed</Button>} */}
                                        <Button className='btn btn-primary d-inline-block float-end  rounded my-3 d-none d-md-block' onClick={handleProceed}>  {isFormValid ? "Continue" : "Proceed"}</Button>
                                        <Modal
                                            className='Gallery_cntr p-0'
                                            open={isModalTravellerDetails}
                                            footer={null}
                                            onCancel={() => setIsModalOpenTravellerDetails(false)}
                                            centered
                                            destroyOnClose={true}
                                        >
                                            <TravellerDetails
                                                selectPayloadData={selectPayloadData}
                                                onPayment={onPayment}
                                                convenienceCharge={convenienceCharge}
                                                swtFee={swtFee}
                                                applicableChargeData={applicableChargeData}
                                                flightDetails={flightDetails}
                                                totalPriceBaggages={totalPriceBaggages}
                                                setIsModalOpenTravellerDetails={setIsModalOpenTravellerDetails}
                                                calculatedFee={calculatedFee}
                                                finalTotal={finalTotal}
                                                couponId={couponId}
                                                setCouponId={setCouponId}
                                                applyDiscountShow={applyDiscountShow}
                                                setApplyDiscountShow={setApplyDiscountShow}
                                                discountAmountOffer={discountAmountOffer}
                                                setDiscountAmountOffer={setDiscountAmountOffer}
                                                meelBaggegasData={meelBaggegasData}
                                            />

                                            {addonsCompHide && (
                                                <div className="text-end">
                                                    <Button
                                                        type="primary"
                                                        className="tabs-popup-btn fw-bold mt-2 mx-2"
                                                        onClick={() => setIsModalOpenTravellerDetails(false)}
                                                    >
                                                        Edit
                                                    </Button>

                                                    <Button
                                                        type="primary"
                                                        className="tabs-popup-btn fw-bold mt-2"
                                                        onClick={() => {
                                                            if (
                                                                Object.keys(meelBaggegasData?.Flight?.mealsDynamic || {}).length > 0 ||
                                                                Object.keys(meelBaggegasData?.Flight?.baggageDynamic || {}).length > 0 ||
                                                                Object.keys(meelBaggegasData?.Flight?.seatDynamic || {}).length > 0
                                                            ) {
                                                                setAddonsCompHide(false);
                                                                setIsModalOpenTravellerDetails(false);
                                                                setCollapseCard(false);
                                                                handleScroll();
                                                            } else {
                                                                handleConfirmAndPay();
                                                            }
                                                        }}
                                                    >
                                                        {(
                                                            Object.keys(meelBaggegasData?.Flight?.mealsDynamic || {}).length > 0 ||
                                                            Object.keys(meelBaggegasData?.Flight?.baggageDynamic || {}).length > 0 ||
                                                            Object.keys(meelBaggegasData?.Flight?.seatDynamic || {}).length > 0
                                                        ) ? 'Confirm' : 'Confirm and pay'}
                                                    </Button>
                                                </div>
                                            )}

                                        </Modal>

                                    </div>
                                }
                            </div>
                        </Skeleton>
                    </Form>
                }
                {!addonsCompHide &&
                    <>
                        <div ref={component4Ref}>
                            <AddonsFlight
                                getTotalSelectedBaggagesReturn={getTotalSelectedBaggagesReturn}
                                getTotalSelectedBaggages={getTotalSelectedBaggages}
                                location={location}
                                flightDetails={flightDetails}
                                setSelectedBaggages={setSelectedBaggages}
                                selectedBaggages={selectedBaggages}
                                totalAmount={totalAmount}
                                setTotalAmount={setTotalAmount}
                                addBaggage={addBaggage}
                                removeBaggage={removeBaggage}
                                totalSelectedTravellers={totalSelectedTravellers}
                                addMeal={addMeal}
                                removeMeal={removeMeal}
                                selectedMeals={selectedMeals}
                                addonsCompHide={addonsCompHide}
                                loading={loading}
                                selectedMealsReturn={selectedMealsReturn}
                                addMealReturn={addMealReturn}
                                mealTotalAmountRetrun={mealTotalAmountRetrun}
                                removeMealReturn={removeMealReturn}
                                handleConfirmAndPay={handleConfirmAndPay}
                                handleSkipAddon={handleSkipAddon}

                                meelBaggegasData={meelBaggegasData}
                                errorMeelBaggegas={errorMeelBaggegas}

                                selectedBaggagesReturn={selectedBaggagesReturn}
                                setSelectedBaggagesReturn={setSelectedBaggagesReturn}
                                totalAmountReturn={totalAmountReturn}
                                setTotalAmountReturn={setTotalAmountReturn}
                                addBaggageReturn={addBaggageReturn}
                                removeBaggageReturn={removeBaggageReturn}

                                setSkipAddons={setSkipAddons}
                                setConvenienceChargeTotalFareModal={setConvenienceChargeTotalFareModal}
                                skipAddonAndPayNow={skipAddonAndPayNow}


                                rowsByFlight={rowsByFlight}
                                setRowsByFlight={setRowsByFlight}
                                legends={legends}
                                setLegends={setLegends}
                                selectedSeats={selectedSeats}
                                setSelectedSeats={setSelectedSeats}
                                totalPrice={totalPrice}
                                setTotalPrice={setTotalPrice}
                                handleSeatClick={handleSeatClick}

                                rowsByFlightReturn={rowsByFlightReturn}
                                setRowsByFlightReturn={setRowsByFlightReturn}
                                legendsReturn={legendsReturn}
                                setLegendsReturn={setLegendsReturn}
                                selectedSeatsReturn={selectedSeatsReturn}
                                setSelectedSeatsReturn={setSelectedSeatsReturn}
                                totalPriceReturn={totalPriceReturn}
                                setTotalPriceReturn={setTotalPriceReturn}
                                handleSeatClickReturn={handleSeatClickReturn}
                                setMealTotalAmount={setMealTotalAmount}
                                setSelectedMeals={setSelectedMeals}
                                setMealTotalAmountReturn={setMealTotalAmountReturn}
                                setSelectedMealsReturn={setSelectedMealsReturn}
                            />
                        </div>
                    </>
                }
                <div className='footer-price d-md-none'>
                    <div className='footer-price-content'>
                        <div>
                            {loading ? (
                                <div className="d-flex align-items-center gap-2">
                                    {/* <Spin className="ms-2" indicator={<LoadingOutIcon widt={'30px'} />} size="small" /> */}
                                    <div className="spinner"></div>
                                </div>
                            ) : (
                                <>
                                    <h2 className="fw-bold d-flex align-items-center gap-2">
                                        {/* ₹{totalPriceBaggages} */}
                                        ₹{!applyDiscountShow ? totalPriceBaggages : Math.round(totalAfterDiscount)}
                                        <Popover
                                            content={
                                                <div>
                                                    <ul className="price-details">
                                                        {flightDetails?.flightDetails?.fareRules?.ADULT > 0 && (
                                                            <li className="d-flex justify-content-between">
                                                                {flightDetails?.flightDetails?.fareRules?.ADULT === 1 ? "Adult" : "Adults"} * {flightDetails?.flightDetails?.fareRules?.ADULT}
                                                                <b>₹{flightDetails?.flightDetails?.fareRules?.ADULT_BF || 0}</b>
                                                            </li>
                                                        )}

                                                        {flightDetails?.flightDetails?.fareRules?.CHILD > 0 && (
                                                            <li className="d-flex justify-content-between">
                                                                {flightDetails?.flightDetails?.fareRules?.CHILD === 1 ? "Child" : "Children"} * {flightDetails?.flightDetails?.fareRules?.CHILD}
                                                                <b>₹{flightDetails?.flightDetails?.fareRules?.CHILD_BF || 0}</b>
                                                            </li>
                                                        )}

                                                        {flightDetails?.flightDetails?.fareRules?.INFANT > 0 && (
                                                            <li className="d-flex justify-content-between">
                                                                {flightDetails?.flightDetails?.fareRules?.INFANT === 1 ? "Infant" : "Infants"} * {flightDetails?.flightDetails?.fareRules?.INFANT}
                                                                <b>₹{flightDetails?.flightDetails?.fareRules?.INFANT_BF || 0}</b>
                                                            </li>
                                                        )}
                                                        <li className="d-flex justify-content-between">Tax & Surcharges <b>₹{flightDetails?.flightDetails?.fareRules?.taxFare}</b></li>
                                                        {applyDiscountShow && discountAmountOffer > 0 && (
                                                            <li className="d-flex justify-content-between">
                                                                Discount <span className="text-danger">₹{Math.round(discountAmountOffer)}</span>
                                                            </li>
                                                        )}
                                                        {(totalSeatsPrice > 0 || totalSeatsPriceReturn > 0) && (
                                                            <li className='d-flex justify-content-between'>
                                                                Seats <span>₹{totalSeatsPrice + totalSeatsPriceReturn}</span>
                                                            </li>
                                                        )}
                                                        {(mealTotalAmount > 0 || mealTotalAmountRetrun > 0) && (
                                                            <li className='d-flex justify-content-between'>
                                                                Meal <span>₹{mealTotalAmount + mealTotalAmountRetrun}</span>
                                                            </li>
                                                        )}

                                                        {(totalAmount > 0 || totalAmountReturn > 0) && (
                                                            <li className='d-flex justify-content-between'>
                                                                Baggage <span>₹{totalAmount + totalAmountReturn}</span>
                                                            </li>
                                                        )}
                                                        {applyDiscountShow && discountAmountOffer > 0 && (
                                                            <li className="d-flex justify-content-between">
                                                                Discount <span className="text-danger">₹{Math.round(discountAmountOffer)}</span>
                                                            </li>
                                                        )}
                                                    </ul>
                                                    <div className="text-center mt-2 bg-light-success p-1 rounded">
                                                        {!applyDiscountShow ? (
                                                            <><h3 className='d-flex justify-content-between'>Total : <span style={{ fontWeight: 'bold' }}>₹{totalPriceBaggages}</span></h3></>) : (
                                                            <><h3 className='d-flex justify-content-between'>Total : <span style={{ fontWeight: 'bold' }}>₹{Math.round(totalAfterDiscount)}</span></h3></>
                                                        )}
                                                    </div>
                                                </div>
                                            }
                                            title="Payment Detail"
                                            trigger="click"
                                            open={open}
                                            onOpenChange={handleOpenChange}
                                            className="booking-filter"
                                        >
                                            <span><FaInfoCircle /></span>
                                        </Popover>
                                    </h2>
                                    <p>
                                        For
                                        {(() => {
                                            const adults = flightDetails?.flightDetails?.fareRules?.ADULT || 0;
                                            const children = flightDetails?.flightDetails?.fareRules?.CHILD || 0;
                                            const infants = flightDetails?.flightDetails?.fareRules?.INFANT || 0;
                                            const totalTravelers = adults + children + infants;
                                            return ` ${totalTravelers} `;
                                        })()}
                                        Travellers
                                    </p>
                                </>
                            )}

                        </div>
                        {addonsCompHide && <Button className='btn btn-primary d-inline-block float-end  rounded my-3' onClick={handleProceed}> {isFormValid ? "Continue" : "Proceed"}</Button>}

                        {!addonsCompHide &&
                            <Button
                                // onClick={() => handleConfirmAndPay()}
                                onClick={() => setConvenienceChargeTotalFareModal(true)}
                                style={{ height: "38px" }}
                                className='btn btn-light menu-block fw-bold rounded'>
                                Continue To Pay
                            </Button>
                        }
                    </div>

                    {/* {addonsCompHide && <Button htmlType="submit" className='btn btn-primary d-inline-block float-end rounded my-3'> Proceed</Button>} */}

                </div>

                {/* </Form> */}
            </div>

            <div className='d-flex justify-content-center'>
                {!addonsCompHide &&
                    <Button
                        // onClick={() => handleConfirmAndPay()}
                        onClick={() => setConvenienceChargeTotalFareModal(true)}
                        style={{ height: "38px" }}
                        className='btn btn-primary menu-block rounded mt-3 m-auto'>
                        Continue To Pay
                    </Button>
                }
            </div>

            <Modal
                className='Gallery_cntr p-0'
                open={convenienceChargeTotalFareModal}
                footer={null}
                onCancel={() => setConvenienceChargeTotalFareModal(false)}
                centered
                destroyOnClose={true}
            >
                {convenienceCharge && (
                    <ConvenienceChargeTotalFare
                        convenienceCharge={convenienceCharge}
                        flightDetails={flightDetails}
                        calculatedFee={calculatedFee}
                        applyDiscountShow={applyDiscountShow}
                        discountAmountOffer={discountAmountOffer}
                        finalTotal={finalTotal}
                        handleConfirmAndPay={handleConfirmAndPay}
                        handleSkipAddon={handleSkipAddon}
                        mealTotalAmount={mealTotalAmount}
                        totalAmount={totalAmount}
                        totalAmountReturn={totalAmountReturn}
                        totalPriceBaggages={totalPriceBaggages}
                        mealTotalAmountRetrun={mealTotalAmountRetrun}
                        totalSeatsPrice={totalSeatsPrice}
                        totalSeatsPriceReturn={totalSeatsPriceReturn}
                    />
                )}

            </Modal>

            <Modal
                className='Gallery_cntr p-0'
                open={isModalOpen}
                footer={null}
                onCancel={() => setIsModalOpen(false)}
                centered
                destroyOnClose={true}
            >
                <DepartureBaggageDetails flightDetails={flightDetails} />
            </Modal>

            <Modal
                className='Gallery_cntr p-0'
                open={isModalOpenReturn}
                footer={null}
                onCancel={() => setIsModalOpenReturn(false)}
                centered
                destroyOnClose={true}
            >
                <ReturnBaggageDetails flightDetails={flightDetails} />
            </Modal>



            <Modal
                className='Gallery_cntr p-3'
                open={bookingProceedLoader}
                footer={null}
                onCancel={() => { setBookingProceedLoader(false), setProceedErrorMessageHide(false) }}
                centered
                destroyOnClose={true}
                width={400}
            >
                <div className='text-center py-5'>
                    <img loading="lazy" src={flightLoader} style={{ height: "100px", width: "100px" }} alt='loader' /><br />

                    {proceedErrorMessageHide ? <h4 className='text-danger'>{proceedErrorMessage}</h4> : <h4>Loading ...</h4>}
                </div>
            </Modal>

            <Modal
                className='Gallery_cntr p-3'
                open={bookingLoader}
                footer={null}
                onCancel={() => { setBookingLoader(false), setBookingMessageError(false) }}
                centered
                destroyOnClose={true}
                width={400}
            >
                {!bookingMessageError ?
                    <div className='text-center py-5'>
                        <img loading="lazy" src={flightLoader} style={{ height: "100px", width: "100px" }} alt='loader' />
                        <h4>Loading ...</h4>
                    </div>
                    :

                    <div className='text-center py-5' >
                        <h4 style={{ color: "red" }}>{bookingMessage}</h4>
                    </div>
                }
            </Modal>



        </>

    )
}

export default BookingFlight